import React from 'react'
import delve from 'dlv'
import classnames from 'classnames/bind'

import LabelTitleText from 'components/shared/LabelTitleText'
import CardsSectionCard from './CardsSectionCard'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const CardsSection = ({ className, intro, cards }) => {
  return (
    <div className={cx(css.CardsSection, className)}>
      {intro && <LabelTitleText {...intro} />}
      {cards && (
        <ul className={css.cards}>
          {cards.map(({ theme, link, card }, index) => {
            const title = delve(card, 'title')
            const text = delve(card, 'text')
            const icon = delve(card, 'icon')

            return (
              <CardsSectionCard
                key={index}
                index={index}
                link={link}
                theme={theme}
                icon={icon}
                title={title}
                text={text}
              />
            )
          })}
        </ul>
      )}
    </div>
  )
}

CardsSection.defaultProps = {
  cards: [],
}

export default CardsSection
